var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"copyAnimation","appear":"","appear-active-class":"copy-animation"}},[_c('footer',[_c('small-tag'),_vm._v(" "),_c('div',{attrs:{"id":"copyright"}},[_vm._v("\n      256pages © 2017\n    ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-660a9265","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/PageFooter.vue
// module id = j+Bk
// module chunks = 1